export type ChatDensity = 'comfy' | 'compact';
export const defaultChatDensity: ChatDensity = 'comfy';
